import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
} from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import { Global } from './Global';
import { DEV_CREDENTIALS } from './LocalStorageKeys';
import { usePersistedState } from './common/hooks/usePersistedState';
import { clearStoredToken } from './common/lib/fetchWrapper';

type Backend = 'localhost' | 'legoasutv01';

interface DevSettingsData {
  username: string;
  password: string;
  backend: Backend;
}

const initialState: DevSettingsData = {
  username: '',
  password: '',
  backend: 'localhost',
};

const DevSettings = () => {
  const [state, setState] = usePersistedState<DevSettingsData>(
    DEV_CREDENTIALS,
    initialState
  );

  useEffect(() => {
    Global['username'] = state.username;
    Global['password'] = state.password;
    Global['backend'] = state.backend;
    clearStoredToken();
  }, [state]);

  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    Global[e.currentTarget.name] = e.currentTarget.value;
    setState({ ...state, [e.currentTarget.name]: e.currentTarget.value });
  };

  const menuItems = ['legoasutv01', 'localhost'].map((t) => (
    <MenuItem key={t} value={t}>
      {t}
    </MenuItem>
  ));

  function handleBackendChange(e: SelectChangeEvent<Backend>) {
    const backend = e.target.value as Backend;
    setState({ ...state, backend });
  }

  return (
    <Stack direction={'row'} spacing={1}>
      <TextField
        name="username"
        value={state.username}
        label={'Användarnamn'}
        onChange={handleInput}
        size={'small'}
      />
      <TextField
        name="password"
        type={'password'}
        value={state.password}
        label={'Lösenord'}
        size={'small'}
        onChange={handleInput}
      />

      <FormControl sx={{ width: '300px' }}>
        <InputLabel>Backend</InputLabel>
        <Select
          value={state.backend}
          label="Typ av förteckning"
          size="small"
          onChange={(e) => handleBackendChange(e)}
        >
          {menuItems}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default DevSettings;
